export function checkPhone(num) {
  const validRegex = /^[\+]?[0-9]{5,}$/im;
  //   /^[\+]?[(]?[0-9]{3,}[)]?[-\s\.]?[0-9]{2,}[-\s\.]?[0-9]{2,}$/im;
  return num.match(validRegex) ? false : true;
}
